import React from 'react';
import ContactSales from './ContactSales';
import InfoCards from './InfoCards';
import './PricingAndPackaging.scss';
import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/eds-button';
import SubscriptionTools from './SubscriptionTools';
import PricingAndPackagingHero from './rightSizePricingHero/PricingAndPackagingHero';
import PricingAndPackagingComparisonCards from './PricingAndPackagingComparisonCards';

export const PricingAndPackaging = () => {
    return (
        <div className="pricing-and-packaging-page">
            <PricingAndPackagingHero />
            <PricingAndPackagingComparisonCards />
            <SubscriptionTools />
            <div className="banner-text">
                <p>+63%</p>
                <p>
                    {gettext(
                        'More tickets sold when organizers use our all-in-one marketing-tools**',
                    )}
                </p>
            </div>
            <InfoCards />
            <div className="get-started">
                <p
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: gettext(
                            "Eventbrite drove <span class='percentage'>30%</span> of paid ticket sales for event organizers in 2022",
                        ),
                    }}
                />
                <Button
                    style="fill"
                    onClick={() => {
                        window.location.href =
                            '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
                    }}
                >
                    {gettext('Get started for free')}
                </Button>
            </div>
            <div className="disclaimer">
                {gettext(
                    '** Eventbrite data 3/1/2022 - 9/30/2022 comparing events promoted both with and without marketing tools; creators must have hosted events with and without a subscription in the last 9 months.',
                )}
            </div>
        </div>
    );
};

export default PricingAndPackaging;
